import { all, fork } from 'redux-saga/effects';

import type { SagaIterator } from '@redux-saga/types';

import entries from './entries';
import oneClickBet from './oneClickBet';
import refreshAvailability from './refreshAvailability';
import refreshBigStakes from './refreshBigStakes';
import refreshFreeBets from './refreshFreeBets';
import submission from './submission';
import updateCheckedStateType from './updateCheckedStateType';

// Bet slip root saga.
export default function* betSlipSaga(): SagaIterator {
  yield all([
    fork(oneClickBet),
    fork(entries),
    fork(refreshAvailability),
    fork(refreshBigStakes),
    fork(refreshFreeBets),
    fork(submission),
    fork(updateCheckedStateType),
  ]);
}
